import { SUPPORT_EMAIL, AJAX_URL } from '../utilities/constants'

export default class {
  constructor(el, options) {
    const LOADING_CLASS = 'is-loading'

    const messageEl = el.querySelector('.js-formMessage')
    const submitEl = el.querySelector('.js-formSubmit')

    if (messageEl && messageEl?.textContent?.length) {
      messageEl.removeAttribute('hidden')
      messageEl.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      })
    }

    if (options.static) {
      return
    }

    const inputs = el.querySelectorAll('input, textarea')
    Array.from(inputs).forEach((inputEl) => {
      inputEl.addEventListener('change', function (e) {
        if (!inputEl.value) {
          inputEl.classList.add('is-empty')
        } else if (inputEl.classList.contains('is-empty')) {
          inputEl.classList.remove('is-empty')
        }
      })

      if (!inputEl.value) {
        inputEl.classList.add('is-empty')
      } else if (inputEl.classList.contains('is-empty')) {
        inputEl.classList.remove('is-empty')
      }
    })

    el.addEventListener('submit', async function (e) {
      e.preventDefault()

      try {
        messageEl.setAttribute('hidden', true)
        messageEl.innerHTML = ''

        if (submitEl) {
          submitEl.classList.add(LOADING_CLASS)
        }

        const formData = new FormData(e.currentTarget)

        const response = await fetch(AJAX_URL, {
          method: 'POST',
          body: formData,
          mode: 'same-origin',
          credentials: 'same-origin',
        })

        console.info(response)

        const json = await response.json()

        const data = json?.data || json

        console.info(data)

        if (data.message) {
          messageEl.removeAttribute('hidden')

          if (Array.isArray(data.message)) {
            messageEl.innerHTML = data.message.join('<br>')
          } else {
            messageEl.innerHTML = data.message
          }

          messageEl.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest',
          })
        }
      } catch (e) {
        console.error({ e })

        messageEl.removeAttribute('hidden')
        messageEl.innerHTML = `${e.toString()} (Something went wrong, try again or contact us at ${SUPPORT_EMAIL})`
        messageEl.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
        })
      } finally {
        submitEl.classList.remove(LOADING_CLASS)
      }

      return false
    })
  }
}
